import { useState, useEffect, useRef, useMemo } from 'react';
import { useAppContext } from "@src/contexts/App/AppContext";

import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";

import Co2Api from '@src/api/Co2Api';
import { useIState } from "@src/hooks/react"

import FieldError from "./UI/FieldError";

import { Trans, t } from '@lingui/macro';

const phoneRegExp = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im

const LeadForm = () => {

    const [appState, AppActions] = useAppContext();

    let [error, setError] = useIState(null);

    const schema = useMemo(() => {
        return yup.object({
            name: yup.string().required(t`Campo richiesto`),
            surname: yup.string().required(t`Campo richiesto`),
            company: yup.string().required(t`Campo richiesto`),
            phone: yup.string().required(t`Campo richiesto`).matches(phoneRegExp, t`Numero di telefono non valido`),
            //email: yup.string().required(t`Campo richiesto`).email(t`Email non valida`),
        }).required();
    }, []);

    const { register, handleSubmit, watch, formState: { errors } } = useForm({
        resolver: yupResolver(schema)
    });

    const abortLoad = useRef(null);

    useEffect(() => {
        return () => {
            if (abortLoad.current) {
                abortLoad.current.abort()
            }
        }
    }, []);

    const onSubmit = (data) => {
        AppActions.isLoading(true);

        if (abortLoad.current) {
            abortLoad.current.abort()
        }
        abortLoad.current = new AbortController();

        let request = {
            lead: { ...data, ...appState.lead },
            statistics: appState.statistics,
            lang: co2_form_info.lang
        };

        Co2Api.post("lead/", request)
            .then(function (response) {
                AppActions.showThx(true);
                console.log(response);
            }).catch(function (error) {
                let errorMsg = t`Impossibile contattare il server riprova`;
                setError(pre => error?.response?.data?.message ?? errorMsg);
                console.log(error);
            }).then(function () {
                AppActions.isLoading(false);
            })
    }

    return (
        <>
            <div className='fs-4 fw-bold mb-3'>
                <Trans>
                    Richiedi una DEMO per il report completo ESG con centinaia di parametri e scopri i vantaggi del programma Partners Green Web Meter
                </Trans>
            </div>

            <form onSubmit={handleSubmit(onSubmit)} className='mb-2'>
                <div className="mb-3">
                    <input type="text" className="form-control rounded-5" placeholder={t`Nome*`} {...register("name")} />
                    <FieldError message={errors.name?.message} />
                </div>

                <div className="mb-3">
                    <input type="text" className="form-control rounded-5" placeholder={t`Cognome*`} {...register("surname")} />
                    <FieldError message={errors.surname?.message} />
                </div>

                <div className="mb-3">
                    <input type="text" className="form-control rounded-5" placeholder={t`Azienda*`} {...register("company")} />
                    <FieldError message={errors.company?.message} />
                </div>

                <div className="mb-3">
                    <input type="text" className="form-control rounded-5" placeholder={t`Telefono*`} {...register("phone")} />
                    <FieldError message={errors.phone?.message} />
                </div>

                <div className='row gy-2'>
                    <div className='col-md'>

                        <div className="form-check">
                            <input className="form-check-input" type="checkbox" value="1" required />
                            <label className="form-check-label">
                                &nbsp;
                                <Trans>
                                    Ho letto e accetto <a href="https://www.iubenda.com/privacy-policy/68120255" target='_blank'>l'informativa privacy</a>
                                </Trans>
                            </label>
                        </div>

                    </div>
                    <div className='col-md text-md-end'>
                        <button type="submit" className="btn btn-primary px-5 rounded-5" disabled={appState.isLoading}>
                            <Trans>Prenota una Demo</Trans>
                        </button>
                    </div>
                </div>

            </form>

            {error ? (<div className="invalid-feedback d-block">{error}</div>) : null}
        </>


    );

}

export default LeadForm;
